/* eslint react/prop-types: 0 */
import { FormInput } from 'camino-react'
import React from 'react'
import Select from 'react-select'

const ProblemCondition = ({
  update,
  predicates: {
    problem,
    problem_id: problemID
  },
  options: { problems }
}) => {
  const assignedOptions = [
    { label: 'Yes', value: true },
    { label: 'No', value: false }
  ]

  return (
    <>
      <FormInput label="Assigned to problem?">
        <Select
          options={assignedOptions}
          value={problem}
          onChange={e => update('problem', e.value)}
        />
      </FormInput>

      {problem && (
        <FormInput label="Problem">
          <Select
            options={problems}
            value={problemID}
            onChange={e => update('problem_id', e.value)}
          />
        </FormInput>
      )}
    </>
  )
}

export default ProblemCondition
